import { ChangeDetectionStrategy, Component, HostBinding, inject } from '@angular/core';
import { AzavistaButtonModule } from '@azavista/components/button';
import { CustomerChatbotService } from '../types';
import { OnsiteCheckInClientAuthService } from '../../onsite-checkin-client/onsite-checkin-client-auth.service';

@Component({
  selector: 'aoc-customer-chatbot-close-button',
  imports: [
    AzavistaButtonModule
  ],
  templateUrl: `./close-button.html`,
  styleUrl: './close-button.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.is-authenticated]': 'isAuthenticated()'
  }
})
export class CloseButtonComponent {
    chatBotSvc = inject(CustomerChatbotService);
    authSvc = inject(OnsiteCheckInClientAuthService);

    get isAuthenticated() {
        return this.authSvc.isAuthenticated$;
    }

    close = () => {
        this.chatBotSvc.hideTemporarily();
    };
}
